<template>
  <div class="table-box" ref="tableBox">
    <el-table ref="table" :data="standardTableData" height="360" header-cell-class-name="risk-table-header"
              cell-class-name="kpi-cell-padding cell-class"
              @sort-change="changeTableSort">
      <el-table-column label="#" prop="idx" type="index" class-name="kpi-border-column" width="45" align="center">
      </el-table-column>
      <el-table-column prop="name" label="指标项" width="300" class-name="kpi-border-column">
        <template slot-scope="scope">
          <div class="name" @click="onNameClick(scope.row)">
            {{ scope.row.kpiName }}
          </div>
        </template>
      </el-table-column>
      <el-table-column v-for="month in 12" :key="month" :label="month+'月'" :prop="'month'+month" sortable="custom">
        <template slot-scope="scope">
          <el-popover
            placement="top-start"
            trigger="hover"
            :disabled="!scope.row['month'+month]"
            :visible-arrow="false"
            popper-class="popper-core-risk-kpi">
            <div v-if="isAirTypeSensitive(scope.row['month'+month])">
              <div class="popper-title">分机型信息</div>
              <div class="ac-data-box" v-for="item in scope.row['month'+month].airTypeData">
                <div class="ac-type">{{ item.airType }}</div>
                <div class="ac-value">{{ item.displayActualValue }}</div>
              </div>
            </div>

            <div v-if="!isAirTypeSensitive(scope.row['month'+month])">
              <div class="popper-title">实际值</div>
              <div class="popper-title">
                {{ scope.row['month' + month] && scope.row['month' + month].displayActualValue }}
              </div>
            </div>
            <span slot="reference" class="kpi-cell-level"
                  :class="getKpiCellLevelStyle(scope.row['month'+month])"
                  @click="onKpiMonthClick(scope.row, month)"></span>
          </el-popover>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import {getRequest} from "../../../utils/request";
import {showMessage} from "../../../utils/notice";

export default {
  props: {
    //核心风险(代码)
    coreRisk: String,
    //典型事件代码
    insecurity: String,
    //危险源Id
    dangerId: Number,
    //系统
    system: String,
    //子流程Id
    subProcessId: Number,
    //年份
    year: Number,
  },
  data() {
    return {
      tableData: [],
      //镜像，保存初次加载时的tableData，排序会修改tableData，清除排序时，用镜像还原
      tableDataMirror: [],
      //KPI类型
      kpiType: null,
    }
  },
  mounted() {
    this.buildData();
  },
  methods: {
    buildData() {
      this.$emit("update:kpiCode", null);
      this.$refs.table.clearSort();
      if (this.coreRisk) {
        getRequest("/risk/dwkpi/getListByconsequence", {
          consequence: this.coreRisk,
          insecurity: this.insecurity,
          dangerId: this.dangerId,
          year: this.year
        }, this.$refs.tableBox).then(res => {
          this.tableData = res.data || [];
          this.tableDataMirror = this.tableData.slice(0);
          //默认按xx月降序
          // this.changeTableSort({prop: 'month3', order: 'descending'});
        })
        this.kpiType = "CR";
      } else if (this.system) {
        getRequest("/process/key/round-spot", {
          system: this.system,
          subProcessId: this.subProcessId,
          year: this.year
        }, this.$refs.tableBox).then(res => {
          this.tableData = res.data || [];
          this.tableDataMirror = this.tableData.slice(0);
        })
        this.kpiType = "KP";
      } else {
        showMessage("error", "开发时错误")
      }

    },
    /**
     * 点击某个kpi时
     */
    onNameClick(kpi) {
      this.$emit("update:kpiCode", kpi.kpiCode);
    },
    onKpiMonthClick(row, month) {
      let code = row.kpiCode;
      let name = row.kpiName;
      let monthData = row['month' + month];
      //没有颜色，点不过去
      if (!monthData || !monthData.levelColor) return;
      let color = monthData.levelColor;
      let date = new Date(this.year, month - 1, 1).format("yyyy-MM-dd");
      let routeData = this.$router.resolve({
        name: "kpiMonitoring",
        query: {
          startDate: date,
          endDate: date,
          kpiType: this.kpiType,
          kpiCode: code,
          kpiName: name,
          color: color
        }
      });
      window.open(routeData.href, '_blank');
    },
    /**
     * 获取风险等级颜色样式
     */
    getKpiCellLevelStyle(monthData) {
      let color = monthData ? monthData.levelColor : null;
      let style = this.$util.getRiskLevelBgColor(color);
      if (monthData && (monthData.levelColor === "RED" || monthData.levelColor === "YELLOW")) {
        style += " kpi-cell-level-breath";
      }
      //存在颜色，才可以点击
      if (color) {
        style += " kpi-cell-level-click";
      }
      return style;
    },
    /**
     * 是否分机型
     */
    isAirTypeSensitive(monthData) {
      return monthData && monthData.airTypeOption && monthData.airTypeOption.length > 0
    },
    /**
     * 修改排序
     * 1～12月升降序
     */
    changeTableSort(param) {
      //排序的列
      let prop = param.prop;
      //排序规则
      let order = param.order;

      if (!order) {
        //清除排序(使用镜像还原)
        this.tableData = this.tableDataMirror.slice(0);
      } else {
        //按风险等级颜色排序
        this.tableData.sort((rowA, rowB) => {
          let rowAData = rowA[prop];
          let rowBData = rowB[prop];
          let result;
          if (!rowAData) {
            result = -1;
          } else if (!rowBData) {
            result = 1;
          } else {
            result = rowAData.actualValue - rowBData.actualValue;
          }
          //如果是降序，结果取反
          if (order === "descending") result = -result;
          return result;
        })
      }
    },
  },
  watch: {
    coreRisk() {
      this.buildData();
    },
    insecurity() {
      this.buildData();
    },
    dangerId() {
      this.buildData();
    },
    year() {
      this.buildData();
    },
    system() {
      this.buildData();
    },
    subProcessId() {
      this.buildData();
    },
  },
  computed: {
    /**
     * 标准表格数据
     */
    standardTableData() {
      let currentYear = new Date().getFullYear();
      let currentMonth = new Date().getMonth() + 1;

      this.tableData.forEach(data => {
        for (let i = 1; i <= 12; i++) {
          let monthKey = "month" + i;
          let monthData = data[monthKey];
          if (monthData) {
            //修改其monthData，如果区分机型，则用机型最大实际值作为指标的实际值，否则使用第1个机型(为"NONE"，且只有一个)的实际值
            monthData.airTypeData.sort((a, b) => b.actualValue - a.actualValue);
            monthData.actualValue = monthData.airTypeData[0].actualValue;
            //将ALL机型数据置顶
            let typeAllIndex = monthData.airTypeData.findIndex(item => item.airType === "ALL");
            if (typeAllIndex > -1) {
              let typeAllArr = monthData.airTypeData.splice(typeAllIndex, 1);
              monthData.airTypeData.unshift(typeAllArr[0]);
            }
            //实际值处理
            monthData.displayActualValue = monthData.actualValue != null ? monthData.actualValue : "-";
            monthData.airTypeData.forEach(item => {
              let actualValue = item.actualValue;
              item.displayActualValue = actualValue != null ? actualValue : "-";
            });
            //如果颜色为NONE，默认显示绿色
            if (monthData.levelColor && monthData.levelColor === "NONE") {
              monthData.levelColor = "GREEN";
            }
            //如果超过当前月，一律显示灰色
            if (this.year === currentYear && i > currentMonth) {
              monthData.levelColor = null;
            }
          }
        }
      });
      return this.tableData;
    }
  }
}
</script>

<style scoped lang="less">
.table-box {

  /deep/ .kpi-cell-level {
    display: inline-block;
    width: 12px;
    height: 12px;
    border-radius: 50%;
    margin-left: 4px;
  }

  /deep/ .kpi-cell-level-click {
    &:hover {
      cursor: pointer;
    }
  }

  //呼吸灯
  .kpi-cell-level-breath {
    animation-name: breath; /* 动画名称 */
    animation-duration: 2s; /* 动画时长3秒 */
    animation-timing-function: ease-in-out; /* 动画速度曲线：以低速开始和结束 */
    animation-iteration-count: infinite; /* 播放次数：无限 */

    /* Safari and Chrome */
    //-webkit-animation-name: breath; /* 动画名称 */
    //-webkit-animation-duration: 3s; /* 动画时长3秒 */
    //-webkit-animation-timing-function: ease-in-out; /* 动画速度曲线：以低速开始和结束 */
    //-webkit-animation-iteration-count: infinite;
  }

  @keyframes breath {
    from {
      opacity: 0.4; /* 动画开始时的不透明度 */
    }
    50% {
      opacity: 1; /* 动画50% 时的不透明度 */
    }
    to {
      opacity: 0.4; /* 动画结束时的不透明度 */
    }
  }

  //@-webkit-keyframes breath {
  //  from {
  //    opacity: 0.5; /* 动画开始时的不透明度 */
  //  }
  //  50% {
  //    opacity: 1; /* 动画50% 时的不透明度 */
  //  }
  //  to {
  //    opacity: 0.5; /* 动画结束时的不透明度 */
  //  }
  //}

  /deep/ .name {
    color: #4b99fe;

    &:hover {
      cursor: pointer;
    }
  }

  /deep/ .kpi-border-column {
    border-right: 1px solid #EBEEF5;
    border-bottom: 1px solid #EBEEF5;
  }

  /deep/ .kpi-cell-padding {
    padding: 5px 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/achievement/risk/CoreRiskKpi.vue